import { get } from './request';

export async function fetchTaxingUnitPollQuestions (
  baseUrl,
  authenticationToken,
  { id, year }
) {
  const url = `${baseUrl}/taxingunit/${id}/polls/${year}/activequestions`;
  const { body } = await get(authenticationToken, url);
  return body;
}
